import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { NotificationService } from '../../../../../common/services/notification/notification.service';
import { AllocationViewAvailableDocksModel } from '../models/allocation-view-available-docks.model';
import { AllocationViewAvailableDocksService } from './allocation-view-available-docks.service';
import {
  AllocationViewAvailableDocksInitialState,
  AllocationViewAvailableDocksLoad,
} from './allocation-view-available-docks.actions';
import { CustomHttpErrorResponse, Error } from '../../../../../common';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export interface AllocationViewAvailableDocksStateModel {
  availableDocks: AllocationViewAvailableDocksModel;
  loaded: boolean;
}

const initialState: AllocationViewAvailableDocksStateModel = {
  availableDocks: null,
  loaded: false,
};

@State<AllocationViewAvailableDocksStateModel>({
  name: 'allocationViewAvailableDocks',
  defaults: initialState,
})
@Injectable()
export class AllocationViewAvailableDocksState {
  constructor(
    private allocationViewAvailableDocksService: AllocationViewAvailableDocksService,
    private notificationService: NotificationService,
  ) {}

  @Selector()
  static getState(state: AllocationViewAvailableDocksStateModel): AllocationViewAvailableDocksStateModel {
    return state;
  }

  @Selector()
  static getItems(state: AllocationViewAvailableDocksStateModel): AllocationViewAvailableDocksModel {
    return state.availableDocks;
  }

  @Selector()
  static getLoaded(state: AllocationViewAvailableDocksStateModel): boolean {
    return state.loaded;
  }

  @Action(AllocationViewAvailableDocksLoad)
  getAllocationViewList(
    ctx: StateContext<AllocationViewAvailableDocksStateModel>,
    { payload }: AllocationViewAvailableDocksLoad,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.allocationViewAvailableDocksService.getAllocationViewAvailableDocks(payload).pipe(
      map((availableDocks: AllocationViewAvailableDocksModel) => {
        ctx.patchState({
          availableDocks,
          loaded: true,
        });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(AllocationViewAvailableDocksInitialState)
  setInitialState(ctx: StateContext<AllocationViewAvailableDocksInitialState>): void {
    ctx.setState(initialState);
  }
}
